import EmptyState from "@/components/empty-state";
import { Card, CardContent } from "@/components/ui/card";
import { useCurrentEnrollment } from "@/hooks/current-enrollment.hook";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { StatusUp } from "iconsax-react";
import { useAtomValue } from "jotai";
import { FC, HTMLAttributes } from "react";

type WaitingQuestionnaireProps = HTMLAttributes<HTMLDivElement>;

const WaitingQuestionnaire: FC<WaitingQuestionnaireProps> = (props) => {
  const editionId = useAtomValue(currentEditionIdAtom);

  const { currentApplication, currentEdition } =
    useCurrentEnrollment(editionId);

  const showMessage =
    currentEdition?.status === "TO_PUBLISH" &&
    currentApplication?.status === "APPROVED";

  return showMessage ? (
    <Card {...props}>
      <CardContent className="py-12">
        <EmptyState
          className="mx-auto"
          icon={StatusUp}
          message={`Pronto podrás visualizar el Formulario de Postulación de la Edición ${currentEdition.year}. ¡Estamos trabajando en ello!`}
        />
      </CardContent>
    </Card>
  ) : null;
};

export default WaitingQuestionnaire;
